import React  from 'react'
import { Grid, Paper, Typography, Divider,Link } from '@material-ui/core';
import CodeBase from './codeComponent';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';

class BasicVueExample extends React.Component{
    constructor(props){
        super(props);
        window.addEventListener('resize',this.update)
        this.state={
            update:false,
        }

    }
    update=()=>{this.setState({update:(!this.state.update)});}
    normalView=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        return<Grid container justify='center'>
                <Grid item md={10} lg={10}>
                    <Paper style={{padding:'20px',margin:'20px',paddingLeft: '100px',paddingRight: '100px'}}>
                        <Typography  className='textTitle' variant='h4' >Counter example using Vuejs</Typography>
                        <Divider/>
            
                        <Typography className={className}>
                            In this section we will see how to make use of Actumjs to create a simple counter app with Vuejs.
                            <br/>
                            First ,we need to create a new vuejs app.
                            This can be done by using vue CLI.
                        </Typography>
                        <CodeBase
                            lines={["$ vue create counter_app"]}
                        />

                        <Typography className={className}>
                        After that you need to install Actumjs to your project by using npm.
                        </Typography>
                        <CodeBase
                        lines={["$ npm install  @actumjs/actum"]}
                        />
                        <Typography className={className}>
                        Now we will describe our application state as store in src/store/index.js file
                        </Typography>
                        <CodeBase
             lang='js'
                 lines={[
                    "import {createStore} from '@actumjs/actum';\n",
                    "const initialState = { count:0 };\n",
                     "const store = createStore(initialState);\n",
                     "export default store;\n"
                    ]}
                 />
              <Typography className={className}>
               To manipulate data within store we need to define actions 
               that modity the store in seperate file  `src\actions\index.js`
             </Typography>
             <CodeBase
             lang='js'
                 lines={[
`
    //an action to increment counter value
    export function increment(payload,state){
        state.count++;
     }
     //an action to decrement counter value
    export function decrement(payload,state){
        state.count--;
     }
 
`
                    ]}
                 />
                 <Typography className={className}>
                    All actions are required to be added into store to update it.
                    After adding actions to store our src/store/index.js file will look something like this
                 </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                    "import {createStore} from '@actumjs/actum';\n",
                    "import {increment,decrement} from '../actions'\n\n",
                    "const initialState = { count:0 };\n",
                     "const store = createStore(initialState);\n\n",
                     '//adding actions to store\n',
                     'store.addAction("increment",increment);\n',
                     'store.addAction("decrement",decrement);\n\n',
                     "export default store;\n"
                    ]}
                 />
                  <Typography className={className}>
                      Now our store is defined and actions are added to it,further we need to create our counter compoents in src/components/counter.vue,
                      which will display counter value from store and two buttons to increase and decrease counter value.
                 </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                     `
                <template>
                     <div>
                         <input type='text' :value="count"/>
                         <button >increment</button>
                         <button >decrement</button>
                     </div>
                </template>
                <script>
                 import store from '../store'
                 
                 export default {
                     name:'counter',
                     data:function() {
                         let {count}=store.getState()
                         return {
                             count:count,
                         }
                     }
                 }
                 </script>

`
                    ]}
                 />
                  <Typography className={className}>
                      Inorder to trigger an action we need to handle click events of buttons.
                      so we will need to define methods and attach them to our buttons
                 </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                     `
                <template>
                     <div>
                         <input type='text' :value="count"/>
                         <button @click="increment">increment</button>
                         <button @click="decrement">decrement</button>
                     </div>
                 </template>
                 <script>
                 import store from '../store'
                 
                 export default {
                     name:'counter',
                     data:function() {
                         let {count}=store.getState()
                         return {
                             count:count,
                         }
                     },
                     mounted:function(){
                         store.after("increment",this.update)
                         store.after("decrement",this.update)
                     },
                     methods:{
                         increment:function(){ store.trigger("increment");},
                         decrement:function(){ store.trigger("decrement");},
                         update:function(){
                             let {count}=store.getState();
                             this.count=count;
                         }
                     }
                 }
                 </script>
`
                    ]}
                 />
                 <Typography className={className}>
                     Finally we need to render that compoent in our App.vue file as shown below
                 </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                     `
                   <template>
                     <div id="app">
                      <counter />
                     </div>
                   </template>
                   
                   <script>
                   import counter from './components/counter'
                   export default {
                     name: 'App',
                     components:{
                       counter:counter
                     }
                   }
                   </script>
                   `
                    ]}
                 />

               <Grid container justify='space-between' style={{paddingBottom:'50px'}}>
                    <Grid item >
                        <Link href="/examples">
                            <ArrowLeft/>back to examples
                        </Link>
                    </Grid>
                </Grid>


                    </Paper>
                </Grid>
            </Grid>
        }
    mobileView=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        return<Grid container justify='center'>
        <Grid item md={12} lg={12}>
            <div style={{padding:'5px',margin:'20px',}}>
                <Typography  className='textTitle' variant='h4' >Counter example using Vuejs</Typography>
                <Divider/>
    
                <Typography className={className}>
                    In this section we will see how to make use of Actumjs to create a simple counter app with Vuejs.
                    <br/>
                    First ,we need to create a new vuejs app.
                    This can be done by using vue CLI.
                </Typography>
                <CodeBase
                    lines={["$ vue create counter_app"]}
                />

                <Typography className={className}>
                After that you need to install Actumjs to your project by using npm.
                </Typography>
                <CodeBase
                lines={["$ npm install  @actumjs/actum"]}
                />
                <Typography className={className}>
                Now we will describe our application state as store in src/store/index.js file
                </Typography>
                <CodeBase
     lang='js'
         lines={[
             "import {createStore} from '@actumjs/actum';\n",
             "const initialState = { count:0 };\n",
             "const store = createStore(initialState);\n",
             "export default store;\n"
            ]}
         />
      <Typography className={className}>
       To manipulate data within store we need to define actions 
       that modity the store in seperate file  `src\actions\index.js`
     </Typography>
     <CodeBase
     lang='js'
         lines={[
`
    //an action to increment counter value
    export function increment(payload,state){
        state.count++;
     }
     //an action to decrement counter value
    export function decrement(payload,state){
        state.count--;
     }
 
`
            ]}
         />
         <Typography className={className}>
            All actions are required to be added into store to update it.
            After adding actions to store our src/store/index.js file will look something like this
         </Typography>
         <CodeBase
     lang='js'
         lines={[
            "import {createStore} from '@actumjs/actum';\n",
            "import {increment,decrement} from '../actions'\n\n",
            "const initialState = { count:0 };\n",
             "const store = createStore(initialState);\n\n",
             '//adding actions to store\n',
             'store.addAction("increment",increment);\n',
             'store.addAction("decrement",decrement);\n\n',
             "export default store;\n"
            ]}
         />
          <Typography className={className}>
              Now our store is defined and actions are added to it,further we need to create our counter compoents in src/components/counter.vue,
              which will display counter value from store and two buttons to increase and decrease counter value.
         </Typography>
         <CodeBase
     lang='js'
         lines={[
             `
        <template>
             <div>
                 <input type='text' :value="count"/>
                 <button >increment</button>
                 <button >decrement</button>
             </div>
        </template>
        <script>
         import store from '../store'
         
         export default {
             name:'counter',
             data:function() {
                 let {count}=store.getState()
                 return {
                     count:count,
                 }
             }
         }
         </script>

`
            ]}
         />
          <Typography className={className}>
              Inorder to trigger an action we need to handle click events of buttons.
              so we will need to define methods and attach them to our buttons
         </Typography>
         <CodeBase
     lang='js'
         lines={[
             `
        <template>
             <div>
                 <input type='text' :value="count"/>
                 <button @click="increment">increment</button>
                 <button @click="decrement">decrement</button>
             </div>
         </template>
         <script>
         import store from '../store'
         
         export default {
             name:'counter',
             data:function() {
                 let {count}=store.getState()
                 return {
                     count:count,
                 }
             },
             mounted:function(){
                 store.after("increment",this.update)
                 store.after("decrement",this.update)
             },
             methods:{
                 increment:function(){ store.trigger("increment");},
                 decrement:function(){ store.trigger("decrement");},
                 update:function(){
                     let {count}=store.getState();
                     this.count=count;
                 }
             }
         }
         </script>
`
            ]}
         />
         <Typography className={className}>
             Finally we need to render that compoent in our App.vue file as shown below
         </Typography>
         <CodeBase
     lang='js'
         lines={[
             `
           <template>
             <div id="app">
              <counter />
             </div>
           </template>
           
           <script>
           import counter from './components/counter'
           export default {
             name: 'App',
             components:{
               counter:counter
             }
           }
           </script>
           `
            ]}
         />

            <Grid container justify='space-between' style={{paddingBottom:'50px'}}>
                <Grid item >
                    <Link href="/examples">
                        <ArrowLeft/>back to examples
                    </Link>
                </Grid>
            </Grid>

            </div>
        </Grid>
    </Grid>
    }

    render(){
        let content=null;
        if(window.screen.width<=768){
            content=this.mobileView();
        }else{
            content=this.normalView();
        }
        return <div style={{marginTop:'70px',color:'white',marginBottom:"20px"}}>
            {content}
        </div>; 
    }
}
export default BasicVueExample;